import React from 'react';
import { action } from 'mobx';
import { inject, observer } from 'mobx-react';

import { Switch, Route, Link } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';

import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';

import StepByStepFormBlock from './StepByStepFormBlock';

import {
  BMC_BLOCKS_BY_STEPS_ORDER,
  BMC_BLOCKS
} from '../common_components/bmc/bmc_constants';
import { blocksArray } from '../common_components/bmc/bmc_functions';

import { Row, Col, Button } from 'react-bootstrap';
import Steps, { Step } from 'awesome-steps';

import BmcBlockIcon from '../common_components/bmc/BmcBlockIcon';
import { ROUTE_PATH, BLOCK_NAME_BY_KEY } from './constants';
import { STEP_BY_STEP_FORM_COMPONENTS } from './formComponentsArray';
import BmcKonva from './BmcKonva';
import { sectionNameByValue } from './functions';

@inject('rootStore')
@observer
class StepByStepMode extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentStep: 0,
      backToSection: false
    };

    this.handlePrevStep = this.handlePrevStep.bind(this);
    this.handleNextStep = this.handleNextStep.bind(this);
    this.handleTrainStepClick = this.handleTrainStepClick.bind(this);
  }

  blockDescriptionByStation(blockName) {
    const { rootStore, intl } = this.props;

    let station = rootStore.currentStage;

    if (rootStore.isBmcVision) {
      return intl.formatMessage({
        id: `vision_suggests_${blockName}_interactive_question`
      });
    }

    return intl.formatMessage({
      id: `${station}_${blockName}_interactive_question`
    });
  }

  headerTitle(value) {
    const blockNameByKey = BLOCK_NAME_BY_KEY;
    const { intl } = this.props;

    let collection = sectionNameByValue(value);

    if (collection === BMC_BLOCKS.CUSTOMER_RELATIONSHIPS)
      collection = 'customers';

    return `${intl.formatMessage({
      id: blockNameByKey[value].name
    })} (${intl.formatMessage({ id: collection })})`;
  }

  render() {
    const { rootStore, intl } = this.props;
    const { currentBlockStep } = this.props.rootStore;
    const blockName = BLOCK_NAME_BY_KEY[currentBlockStep].name;

    //   console.log("Step by step props", this.props.bmcStore);

    return (
      <div
        style={{ marginLeft: -10, marginTop: 10, marginLeft: -10 }}
        className="col-xs-12 no-padding-xs"
      >
        {!this.state.backToSection && this.renderCloseButton()}
        <BmcKonva
          initialStep={this.state.currentStep}
          title={this.headerTitle(currentBlockStep)}
          description={this.blockDescriptionByStation(blockName)}
          {...this.props}
        />
      </div>
    );
  }

  renderAppFromRoutes() {
    const { rootStore, intl, history } = this.props;

    return (
      <Row>
        <Col xs={12}>
          <Switch>
            {blocksArray().map(block => (
              <Route
                key={`key-route-${block}`}
                path={`${ROUTE_PATH}/step_mode/${block}`}
                component={() => this.renderStepComponent(block)}
              />
            ))}

            {/*<Redirect to={`${history.location.pathname}${BMC_BLOCKS.CUSTOMER_SEGMENTS}`}/>*/}
          </Switch>
        </Col>
      </Row>
    );
  }

  renderStepComponent = block => {
    const { rootStore, intl, history } = this.props;

    const blockStore = rootStore.getBlockStoreByName(block);
    const BlockForm = STEP_BY_STEP_FORM_COMPONENTS[block];

    return (
      <StepByStepFormBlock
        blockStore={blockStore}
        title={this.blockTitleByStation(block)}
      >
        <BlockForm blockStore={blockStore} hideCancelBtn={true} />
      </StepByStepFormBlock>
    );
  };

  renderTrain() {
    const { rootStore, intl } = this.props;
    const labelPlacement = rootStore.isVerySmallWindows ? ' ' : 'vertical';
    const direction = rootStore.isVerySmallWindows ? 'vertical' : 'horizontal';
    const containerClass = rootStore.isVerySmallWindows ? 'container' : '';
    return (
      <Steps
        current={this.state.currentStep}
        labelPlacement={labelPlacement}
        direction={direction}
      >
        {BMC_BLOCKS_BY_STEPS_ORDER.map((block, index) =>
          this.renderTrainStep(block, index)
        )}
      </Steps>
    );
  }

  renderTrainStep = (block, index) => {
    return (
      <Step
        title={this.props.intl.formatMessage({ id: `IgbmcBoard-${block}` })}
        onClick={this.handleTrainStepClick.bind(null, block, index)}
        key={`block-${block}`}
        icon={<BmcBlockIcon block={block} />}
      />
    );
  };

  renderNextButton() {
    const { rootStore, intl } = this.props;
    if (this.state.currentStep !== 8) {
      return (
        <LinkContainer
          to={`${this.baseURL()}/step_mode/${this.nextPath(
            this.state.currentStep
          )}`}
        >
          <Button
            bsStyle="default"
            onClick={this.handleNextStep}
            className="step-btn"
          >
            {intl.formatMessage({ id: 'next' })}
            &nbsp;
            <i className="fa fa-arrow-right" aria-hidden="true" />
          </Button>
        </LinkContainer>
      );
    } else {
      return;
    }
  }

  renderPrevButton() {
    const { rootStore, intl } = this.props;
    if (this.state.currentStep !== 0) {
      return (
        <LinkContainer
          to={`${this.baseURL()}/step_mode/${this.prevPath(
            this.state.currentStep
          )}`}
        >
          <Button
            bsStyle="default"
            onClick={this.handlePrevStep}
            className="step-btn"
          >
            <i className="fa fa-arrow-left" aria-hidden="true" />
            &nbsp;
            {intl.formatMessage({ id: 'back' })}
          </Button>
        </LinkContainer>
      );
    } else {
      return;
    }
  }

  renderCloseButton() {
    const { rootStore, intl, location } = this.props;

    const regex = RegExp(`/${intl.locale}/(memberships|customers)/`);

    if (!location.pathname.match(regex))
      //if (this.state.currentStep == 0) {
      return (
        <Link
          to={`${this.baseURL()}`}
          className="btn btn-default step-btn"
          onClick={() => (rootStore.closeStepByStepMode = true)}
        >
          {intl.formatMessage({ id: 'close' })}
          &nbsp;
          <i className="fa fa-times" aria-hidden="true" />
        </Link>
      );
    //} else {
    //    return;
    //}
  }

  renderFinishButton() {
    const { rootStore, intl } = this.props;

    if (this.state.currentStep === 8) {
      return (
        <Link
          to={`${this.baseURL()}`}
          className="btn btn-primary step-btn"
          onClick={() => (rootStore.closeStepByStepMode = true)}
        >
          {intl.formatMessage({ id: 'finish' })}
          &nbsp;
        </Link>
      );
    } else {
      return;
    }
  }

  handleNextStep() {
    let step = this.state.currentStep + 1;

    if (step <= 9) {
      this.setState({ currentStep: step });
    }
  }

  handlePrevStep() {
    let step = this.state.currentStep - 1;

    if (step >= 0) {
      this.setState({ currentStep: step });
    }
  }

  handleTrainStepClick(step, index) {
    const { rootStore, intl } = this.props;

    this.setState({ currentStep: index });

    this.props.history.push(`${this.baseURL()}/step_mode/${step}`);
  }

  nextPath(step) {
    return BMC_BLOCKS_BY_STEPS_ORDER[step + 1];
  }

  prevPath(step) {
    return BMC_BLOCKS_BY_STEPS_ORDER[step - 1];
  }

  StepFromStringPath(step) {
    return BMC_BLOCKS_BY_STEPS_ORDER.indexOf(step);
  }

  blockTitleByStation(blockName) {
    const { rootStore, intl } = this.props;

    let station = rootStore.currentStage;

    if (rootStore.isBmcVision) {
      return intl.formatMessage({
        id: `vision_suggests_${blockName}_interactive_question`
      });
    }

    return intl.formatMessage({
      id: `${station}_${blockName}_interactive_question`
    });
  }

  baseURL = () => {
    const { history } = this.props;

    let baseUrl = history.location.pathname.substr(
      0,
      history.location.pathname.lastIndexOf('/')
    );
    return baseUrl.substr(0, baseUrl.lastIndexOf('/'));
  };

  componentDidMount() {
    let step = this.props.history.location.pathname.substr(
      this.props.history.location.pathname.lastIndexOf('/') + 1
    );

    this.setState({ currentStep: this.StepFromStringPath(step) });
  }

  @action
  componentWillMount() {
    const { rootStore } = this.props;
    rootStore.closeStepByStepMode = false;
    this.props.rootStore.setStepModeAtIgMvpStore();
    rootStore.stepByStepMode = true;

    let step = this.props.history.location.pathname.substr(
      this.props.history.location.pathname.lastIndexOf('/') + 1
    );

    this.setState({ currentStep: this.StepFromStringPath(step) });

    rootStore.fetchVisionData();
  }

  @action
  componentWillUnmount() {
    const { rootStore } = this.props;
    this.props.rootStore.unsetStepModeAtIgMvpStore();
    rootStore.stepByStepMode = false;
    this.state.backToSection = false;
  }
}

export default withRouter(injectIntl(StepByStepMode));

/*
<div className="full-page no-padding-xs">
                <Row className="interactive no-padding-xs">
                    {!rootStore.oneBlockMode.active && this.renderTrain()}

                    {this.renderAppFromRoutes()}
                </Row>
                <Row className="no-padding-xs">
                    <div className="footer-buttons">
                        {this.renderCloseButton()}
                        {!rootStore.oneBlockMode.active && this.renderPrevButton()}
                        {!rootStore.oneBlockMode.active && this.renderNextButton()}
                        {this.renderFinishButton()}
                    </div>
                </Row>
            </div>
            */
